import React from 'react';
import ButtonNormal from '../../../Buttons/ButtonNormal';
import styled from 'styled-components';


const List = styled.div`
  border-top: 1px solid #e7e7e7;
`;

const Item = styled.div`
  border-bottom: 1px solid #e7e7e7;
  padding: 16px 24px;

  p {
    color: #484848;
    margin-bottom: 7px;
    font-size: 14px;
    &:last-child {
      margin: 0;
    }
  }
  .billingList-actions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    a,div {
        color: #10587f;
        font-size: 12px;
        text-decoration: none;
        margin-right: 13px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
  }
  
`;


const PageButton = styled.button`
  margin: 61px 0;
  cursor: pointer;
  background-color: transparent;
  outline: none;
  border: none;
  line-height: normal;
  font-weight: bold;
  color: #10587f;
  display: flex;
  -webkit-tap-highlight-color: transparent;
`;

const BillingList = ({handleSendInvoice, invoicesData}) => {

  //Format number
  function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  return (
    <>
      <List>
        {invoicesData && invoicesData.data && invoicesData.data.map((bill) => (
          <Item key={bill.id}>
            <p>
              <b>Factura:</b> {bill.id}
            </p>
            <p>
              <b>Concepto:</b> <span>{currencyFormat(bill.items[0].product.price)}</span>
            </p>
            <p>
              <b>Fecha:</b> {bill.created_at.slice(0, 10)}
            </p>
            <p>
              <b>Total:</b> {currencyFormat(bill.total)}
            </p>
            <div className='billingList-actions'>
              <a className='billingList-action' 
              href={`${process.env.REACT_APP_FIREBASE_URLSERVICE}/invoices/download_zip?idInvoice=${bill.id}`}
              download="invoce"
              >
                PDF/XML
              </a>
              {/* <a className='billingList-action' href="*" target="_blank">
                XML
              </a> */}
              <div className='billingList-action' onClick={() => handleSendInvoice(bill.id)}>
                Enviar
              </div>
            </div>
          </Item>
        ))}
      </List>
      {invoicesData && invoicesData.length > 15 && (  //15 elementos por página
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <PageButton>
            Ver más facturas
          </PageButton>
        </div>
      )}

    </>
  );
};

export default BillingList;
